import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { computed, defineComponent, onMounted, ref } from 'vue';
import dayjs from 'dayjs';
import { useRouter } from 'vue-router';
import localCache from '@/utils/localCache';
import { useEmptyStringFormat } from '@/hooks/fn';
import useGuliaoSaleData from './hooks/useGuliaoSaleData';
import useGuliaoSaleSupplierContrast from './hooks/useGuliaoSaleSupplierContrast';
import { PieEchart, BarEchartMul } from '@/components/page-echarts';
import useHourFeed from './hooks/useHourFeed';
import useAggregateTrend from './hooks/useAggregateTrend';
import CTypeTab from '@/components/CTypeTab.vue';
import CNothing from '@/components/CNothing.vue';
import CNoData from '@/components/CNoData.vue';
export default defineComponent({
  name: 'ReportAggregateDaily',
  components: {
    PieEchart: PieEchart,
    BarEchartMul: BarEchartMul,
    CTypeTab: CTypeTab,
    CNothing: CNothing,
    CNoData: CNoData
  },
  setup: function setup() {
    var emptyStringFormat = useEmptyStringFormat();
    // 选择日期
    var confrimDate = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params.value.date = val;
              // hourParams.value.hour = dayjs().format('HH')
              if (params.value.type === 3) {
                getAggregateSaleTrendYearAsync();
              }
              if (params.value.type === 0) {
                //上一小时各供应商进料情况
                // findFeedForHourAsync()
                //日报请求各小时进料情况
                getHourFeedAsync();
              } else {
                getAggregateSaleTrendAsync();
              }
              //获取料类数据返回的结果为供应商列表的第一个个供应商的数据，需要供应商数据才能请求的接口只有排行榜和日报的各小时进料情况
              _context.next = 5;
              return getAggregateSaleDataAsync();
            case 5:
              res = _context.sent;
              if (res.text) {
                supplier.value.text = res.text;
                supplier.value.value = res.value;
                //供应商料类采购排行榜
                getAggregateSupplierContrastAsync();
              } else {
                supplierContrastData.value = [];
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confrimDate(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var dateRef = ref();
    var confirmType = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(val) {
        var _dateRef$value;
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              params.value.type = val;
              // hourParams.value.hour = dayjs().format('HH')
              //把所以日期控件的日期变为当前最新日期
              (_dateRef$value = dateRef.value) === null || _dateRef$value === void 0 || _dateRef$value.reset();
              if (val === 4) {
                params.value.date = dayjs().format('YYYY/MM/DD') + ',' + dayjs().format('YYYY/MM/DD');
              } else {
                params.value.date = dayjs().format('YYYY/MM/DD');
              }
              if (val === 3) {
                getAggregateSaleTrendYearAsync();
              }
              if (params.value.type === 0) {
                //上一小时各供应商进料情况
                // findFeedForHourAsync()
                //日报请求各小时进料情况
                getHourFeedAsync();
              } else {
                getAggregateSaleTrendAsync();
              }
              //获取料类数据返回的结果为供应商列表的第一个个供应商的数据，需要供应商数据才能请求的接口只有排行榜和日报的各小时进料情况
              _context2.next = 7;
              return getAggregateSaleDataAsync();
            case 7:
              res = _context2.sent;
              if (res.text) {
                supplier.value.text = res.text;
                supplier.value.value = res.value;
                //供应商料类采购排行榜
                getAggregateSupplierContrastAsync();
              } else {
                supplierContrastData.value = [];
              }
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function confirmType(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    var switchClick = function switchClick() {
      if (params.value.type === 0) {
        window.location.href = "/table/guliaoBuyDay.html?factoryId=".concat(localCache.getItem('factoryId'));
      }
      if (params.value.type === 1) {
        window.location.href = "/table/guliaoBuyWeek.html?factoryId=".concat(localCache.getItem('factoryId'));
      }
      if (params.value.type === 2) {
        window.location.href = "/table/guliaoBuyMonth.html?factoryId=".concat(localCache.getItem('factoryId'));
      }
    };
    var params = ref({
      date: dayjs().format('YYYY/MM/DD'),
      type: 0 //时间类型 0日数据 1周数据 2月数据
    });
    var _useGuliaoSaleData = useGuliaoSaleData(params),
      _useGuliaoSaleData2 = _slicedToArray(_useGuliaoSaleData, 4),
      aggregateSaleData = _useGuliaoSaleData2[0],
      summaryData = _useGuliaoSaleData2[1],
      columns = _useGuliaoSaleData2[2],
      getAggregateSaleDataAsync = _useGuliaoSaleData2[3];
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var res;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (params.value.type === 0) {
              //上一小时各供应商进料情况
              // findFeedForHourAsync()
              //日报请求各小时进料情况
              getHourFeedAsync();
            } else {
              getAggregateSaleTrendAsync();
            }
            //获取料类数据返回的结果为供应商列表的第一个个供应商的数据，需要供应商数据才能请求的接口只有排行榜和日报的各小时进料情况
            _context3.next = 3;
            return getAggregateSaleDataAsync();
          case 3:
            res = _context3.sent;
            if (res.text) {
              supplier.value.text = res.text;
              supplier.value.value = res.value;
              //供应商料类采购排行榜
              getAggregateSupplierContrastAsync();
            }
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    //日报独有: start
    //各小时进料情况
    var feedingTabs = ref(['吨数(吨)', '车数(车)', '金额(万元)']);
    var feedingTabActive = ref(0);
    var feedingTabClick = function feedingTabClick(index) {
      feedingTabActive.value = index;
      getHourFeedAsync();
    };
    var hourParams = computed(function () {
      return {
        date: params.value.date,
        type: feedingTabActive.value
      };
    });
    var _useHourFeed = useHourFeed(hourParams),
      _useHourFeed2 = _slicedToArray(_useHourFeed, 2),
      dayData = _useHourFeed2[0],
      getHourFeedAsync = _useHourFeed2[1];
    // const hourParams = computed(() => {
    //   return {
    //     date: params.value.date,
    //     hour: dayjs().format('HH')
    //   }
    // })
    // //获取上一小时各供应商进料情况
    // const [feedForHour, findFeedForHourAsync] = useFeedForHour(hourParams)
    //日报独有: end
    // 周月报独有 start
    var _useAggregateTrend = useAggregateTrend(params),
      _useAggregateTrend2 = _slicedToArray(_useAggregateTrend, 4),
      aggregateSaleTrendData = _useAggregateTrend2[0],
      aggregateSaleTrendYearData = _useAggregateTrend2[1],
      getAggregateSaleTrendAsync = _useAggregateTrend2[2],
      getAggregateSaleTrendYearAsync = _useAggregateTrend2[3];
    var saleTrend = computed(function () {
      var list = aggregateSaleTrendData.value.map(function (item) {
        return item.tot_money;
      });
      var xLabels = aggregateSaleTrendData.value.map(function (item) {
        return item.time;
      });
      return {
        lineData: list,
        xLabels: xLabels,
        legendData: ['进料趋势'],
        yName: ''
      };
    });
    var dayDataTrend = computed(function () {
      var lineData1 = aggregateSaleTrendData.value.map(function (item) {
        return item.net_weight;
      });
      var lineData2 = aggregateSaleTrendData.value.map(function (item) {
        return item.tot_money;
      });
      var xLabels = aggregateSaleTrendData.value.map(function (item) {
        return item.time;
      });
      var legendData = ['吨数', '金额'];
      return {
        xLabels: xLabels,
        lineData: [lineData1, lineData2],
        legendData: legendData,
        colors: ['#82A3FF', '#5AC57F', '#EEC324'],
        grid: {
          left: 65,
          top: 10,
          bottom: 55,
          right: 35
        },
        legendBottom: 2,
        customTooltip: true,
        tooptipFormatter: function tooptipFormatter(params1) {
          var res = "\n                  <div >\n                    <div class=\"flex align-center\">\n                      <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                    </div>\n                  ");
          params1.forEach(function (item) {
            res += "\n                    <div >\n                      ".concat(item.marker, "\n                      <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                      <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(item.seriesName === '吨数' ? '吨' : '万元', "</span>\n                    </div>\n                  ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    var dayDataTrend1 = computed(function () {
      var lineData1 = aggregateSaleTrendYearData.value.map(function (item) {
        return item.net_weight;
      });
      var lineData2 = aggregateSaleTrendYearData.value.map(function (item) {
        return item.tot_money;
      });
      var xLabels = aggregateSaleTrendYearData.value.map(function (item) {
        return item.time;
      });
      var legendData = ['吨数', '金额'];
      return {
        xLabels: xLabels,
        lineData: [lineData1, lineData2],
        legendData: legendData,
        colors: ['#82A3FF', '#5AC57F', '#EEC324'],
        grid: {
          left: 65,
          top: 10,
          bottom: 55,
          right: 20
        },
        legendBottom: 2,
        customTooltip: true,
        tooptipFormatter: function tooptipFormatter(params1) {
          var res = "\n                  <div >\n                    <div class=\"flex align-center\">\n                      <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                    </div>\n                  ");
          params1.forEach(function (item) {
            res += "\n                    <div >\n                      ".concat(item.marker, "\n                      <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                      <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(item.seriesName === '吨数' ? '吨' : '万元', "</span>\n                    </div>\n                  ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    // 周月报独有 end
    var tabs = ref(['进料量', '金额']);
    var curTab = ref('进料量');
    var tabClick = function tabClick(val) {
      curTab.value = val;
    };
    var categoryGoodsCount = computed(function () {
      var list = [];
      if (curTab.value === '进料量') {
        list = aggregateSaleData.value.settleValueList.map(function (item, index) {
          return {
            name: item.name,
            value: item.value,
            singular: item.singular,
            itemStyle: {
              color: item.color
            }
          };
        }).filter(function (item) {
          return item.value;
        });
      }
      if (curTab.value === '金额') {
        list = aggregateSaleData.value.totMoneyList.map(function (item, index) {
          return {
            name: item.name,
            value: item.value,
            rawMaterialMoney: item.rawMaterialMoney,
            totalFreight: item.totalFreight,
            itemStyle: {
              color: item.color
            }
          };
        }).filter(function (item) {
          return item.value;
        });
      }
      return {
        pieData: list,
        customLabel: true,
        labelFormatter: function labelFormatter(params) {
          var res = '';
          if (curTab.value === '进料量') {
            res = "".concat(params.name, "\n").concat(params.value, "\u5428\n").concat(params.data.singular, "\u8F66");
          }
          if (curTab.value === '金额') {
            res = "".concat(params.name, "\n\u603B\u91D1\u989D\uFF1A").concat(params.value, "\u4E07\u5143\n\u539F\u6599\u8D39\uFF1A").concat(params.data.rawMaterialMoney, "\u4E07\u5143\n\u8FD0\u8D39\uFF1A").concat(params.data.totalFreight, "\u4E07\u5143\n");
          }
          return res;
        },
        customTooltip: true,
        tooltipFormatter: function tooltipFormatter(params) {
          var res = "\n              <div >\n              ";
          if (curTab.value === '进料量') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                    <div>\n                      <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                      <div>\n                        <span style=\"font-size: 12px;\">").concat(params.value, "\u5428</span>\n                      </div>\n                      <div>\n                        <span style=\"font-size: 12px;\">").concat(params.data.singular, "\u8F66</span>\n                      </div>\n                    </div>\n                  </div>\n                ");
          }
          if (curTab.value === '金额') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                    <div>\n                      <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                      <div>\n                        \u603B\u91D1\u989D\uFF1A<span style=\"font-size: 12px;\">").concat(params.value, "\u4E07\u5143</span>\n                      </div>\n                      <div>\n                        \u539F\u6599\u8D39\uFF1A<span style=\"font-size: 12px;\">").concat(params.data.rawMaterialMoney, "\u4E07\u5143</span>\n                      </div>\n                      <div>\n                        \u8FD0\u8D39\uFF1A<span style=\"font-size: 12px;\">").concat(params.data.totalFreight, "\u4E07\u5143</span>\n                      </div>\n                    </div>\n                  </div>\n                ");
          }
          res += '</div>';
          return res;
        }
      };
    });
    //供应商料类采购排行榜
    var supplier = ref({
      text: '',
      value: ''
    });
    var rankParams = computed(function () {
      return {
        date: params.value.date,
        type: params.value.type,
        supplierNo: supplier.value.value
      };
    });
    var _useGuliaoSaleSupplie = useGuliaoSaleSupplierContrast(rankParams),
      _useGuliaoSaleSupplie2 = _slicedToArray(_useGuliaoSaleSupplie, 2),
      supplierContrastData = _useGuliaoSaleSupplie2[0],
      getAggregateSupplierContrastAsync = _useGuliaoSaleSupplie2[1];
    var show = ref(false);
    var openPopup = function openPopup() {
      show.value = true;
    };
    var onConfirm = function onConfirm(e) {
      // console.log(e, 'eeee');
      show.value = false;
      supplier.value.text = e.selectedOptions[0].text;
      supplier.value.value = e.selectedOptions[0].value;
      getAggregateSupplierContrastAsync();
    };
    var onCancel = function onCancel() {
      show.value = false;
    };
    // const hourShow = ref(false)
    // const hours = ref([
    //   { text: '00', value: 0 },
    //   { text: '01', value: 1 },
    //   { text: '02', value: 2 },
    //   { text: '03', value: 3 },
    //   { text: '04', value: 4 },
    //   { text: '05', value: 5 },
    //   { text: '06', value: 6 },
    //   { text: '07', value: 7 },
    //   { text: '08', value: 8 },
    //   { text: '09', value: 9 },
    //   { text: '10', value: 10 },
    //   { text: '11', value: 11 },
    //   { text: '12', value: 12 },
    //   { text: '13', value: 13 },
    //   { text: '14', value: 14 },
    //   { text: '15', value: 15 },
    //   { text: '16', value: 16 },
    //   { text: '17', value: 17 },
    //   { text: '18', value: 18 },
    //   { text: '19', value: 19 },
    //   { text: '20', value: 20 },
    //   { text: '21', value: 21 },
    //   { text: '22', value: 22 },
    //   { text: '23', value: 23 }
    // ])
    // const openHourPopup = () => {
    //   hourShow.value = true
    // }
    // const onConfirmHour = (e: { text: string; value: number }) => {
    //   hourShow.value = false
    //   hourParams.value.hour = e.text
    //   feedForHour.value = {
    //     feedForSupplier: [],
    //     carNumber: 0,
    //     netWeight: 0
    //   }
    //   findFeedForHourAsync()
    // }
    // const onCancelHour = () => {
    //   hourShow.value = false
    // }
    var router = useRouter();
    var toReportDetail = function toReportDetail() {
      router.push({
        name: 'PurchaseReportDetail',
        params: {
          date: params.value.date,
          type: params.value.type,
          reportType: 'aggregate' //骨料商砼砂浆  报表类型
        }
      });
    };
    return {
      params: params,
      confirmType: confirmType,
      confrimDate: confrimDate,
      switchClick: switchClick,
      emptyStringFormat: emptyStringFormat,
      aggregateSaleData: aggregateSaleData,
      summaryData: summaryData,
      tabs: tabs,
      curTab: curTab,
      tabClick: tabClick,
      categoryGoodsCount: categoryGoodsCount,
      supplierContrastData: supplierContrastData,
      supplier: supplier,
      columns: columns,
      show: show,
      openPopup: openPopup,
      onConfirm: onConfirm,
      onCancel: onCancel,
      // feedForHour,
      saleTrend: saleTrend,
      dayDataTrend: dayDataTrend,
      dayDataTrend1: dayDataTrend1,
      toReportDetail: toReportDetail,
      dateRef: dateRef,
      // hourShow,
      // hours,
      // openHourPopup,
      // onConfirmHour,
      // onCancelHour,
      hourParams: hourParams,
      feedingTabs: feedingTabs,
      feedingTabClick: feedingTabClick,
      feedingTabActive: feedingTabActive,
      dayData: dayData
    };
  }
});